const helpCenter = () => import('@/pages/helpCenter/helpCenter.vue');

export default [{
  path: '/helpCenter',
  name: 'helpCenter',
  meta: {
    isLogin: false
  },
  component: helpCenter
}, ]